// extracted by mini-css-extract-plugin
export var cartContainer = "_pp-4";
export var gray = "_pp-1";
export var itemContainer = "_pp-2";
export var itemDetails = "_pp-3";
export var strong = "_pp-0";